import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import ROUTE_PATHS from '@/consts/route/routePaths';
import useLocationPathname from '@/hooks/useLocationPathname';
import appRouterService from '@/services/route/appRouterService';
import {selectAggregatedSettings} from '@/state/selectors/consumerAggregatedSettings';

const useTncPageRedirection = () => {
    const aggregatedSettings = useSelector(selectAggregatedSettings);
    const isTncRelatedPage = useIsTncRelatedPage();

    useEffect(() => {
        if (isTncRelatedPage) return;
        if (!aggregatedSettings) return;

        const {allMandatoryTermsApproved, allNonMandatoryTermsReviewed} = aggregatedSettings;
        const isTncAccepted = allMandatoryTermsApproved && allNonMandatoryTermsReviewed;

        if (isTncAccepted) return;

        appRouterService.forwardToTncPage();
    }, [aggregatedSettings, isTncRelatedPage]);
};

export default useTncPageRedirection;

const useIsTncRelatedPage = () => {
    const {pathname} = useLocationPathname();

    return pathname === ROUTE_PATHS.TNC || pathname === ROUTE_PATHS.TNC_DETAILS;
};
